import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2 text-xs" }

import { Info } from 'lucide-vue-next';
    import { HoverCardContent, HoverCardPortal, HoverCardRoot, HoverCardTrigger } from 'reka-ui';
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'HoverInfo',
  props: {
    openDelay: { default: 0 },
    closeDelay: { default: 0 },
    content: {},
    class: { default: '' }
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(HoverCardRoot), {
    "open-delay": _ctx.openDelay,
    "close-delay": _ctx.closeDelay
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(HoverCardTrigger), null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "trigger", {}, () => [
            _createVNode(_unref(Info), {
              class: _normalizeClass(_unref(cn)('text-secondary/50 size-3.5 shrink-0', props.class))
            }, null, 8, ["class"])
          ])
        ]),
        _: 3
      }),
      _createVNode(_unref(HoverCardPortal), null, {
        default: _withCtx(() => [
          _createVNode(_unref(HoverCardContent), {
            class: "animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-[300px] rounded-xl border bg-white p-4 shadow-sm data-[state=open]:transition-all",
            "side-offset": 5
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "icon", {}, () => [
                  _createVNode(_unref(Info), { class: "text-secondary size-5 shrink-0" })
                ]),
                _renderSlot(_ctx.$slots, "default", {}, () => [
                  _createTextVNode(_toDisplayString(_ctx.content), 1)
                ])
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["open-delay", "close-delay"]))
}
}

})